export default __webpack_public_path__ + "static/media/logo192.55d3186f.png";